import { create } from 'zustand';

import type {
  AppleAppStoreInfo,
  G2WorkspaceT,
  GooglePlayWorkspaceT,
  HelpScoutWorkspaceT,
  SSTWInfoT,
  TiktokShopWorkspaceT,
} from '@/features/Setting/Integrations/providers/types';
import type { SlackNotificationT } from '@/services/integrations/slack_webhook/types';

type State = {
  SSTWInfoList: SSTWInfoT[];
  slackNotifications: SlackNotificationT[];
  googlePlayStoreWorkspaces: GooglePlayWorkspaceT[];
  appleAppStoreWorkspaces: AppleAppStoreInfo[];
  g2Workspace: G2WorkspaceT | null;
  tiktokShopWorkspace: TiktokShopWorkspaceT | null;
  helpscoutWorkspace: HelpScoutWorkspaceT | null;
};

type Actions = {
  setSlackNotifications: (n: SlackNotificationT[]) => void;
  setGooglePlayStoreWorkspaces: (d: GooglePlayWorkspaceT[]) => void;
  setAppleAppStoreWorkspaces: (a: AppleAppStoreInfo[]) => void;
  setG2Workspace: (g: G2WorkspaceT | null) => void;
  setSSTWInfoList: (info: SSTWInfoT[]) => void;
  setTiktokShopWorkspace: (t: TiktokShopWorkspaceT | null) => void;
  setHelpScoutWorkspace: (w: HelpScoutWorkspaceT | null) => void;
  initIntegrationStore: () => void;
  set: (state: Partial<State>) => void;
};

const initialState: State = {
  SSTWInfoList: [],
  slackNotifications: [],
  googlePlayStoreWorkspaces: [],
  appleAppStoreWorkspaces: [],
  g2Workspace: null,
  tiktokShopWorkspace: null,
  helpscoutWorkspace: null,
};

const useIntegrationStore = create<State & Actions>((set, get) => ({
  ...initialState,
  setSlackNotifications(n) {
    set(() => ({ slackNotifications: n }));
  },
  setGooglePlayStoreWorkspaces: (d) => {
    set((state) => ({ ...state, googlePlayStoreWorkspaces: d }));
  },
  setAppleAppStoreWorkspaces: (a) => {
    set((state) => ({ ...state, appleAppStoreWorkspaces: a }));
  },
  setG2Workspace: (g) => {
    set((state) => ({ ...state, g2Workspace: g }));
  },
  setTiktokShopWorkspace: (t) => {
    set((state) => ({ ...state, tiktokShopWorkspace: t }));
  },
  setSSTWInfoList(info) {
    set({ SSTWInfoList: info });
  },
  setHelpScoutWorkspace: (w) => {
    set((state) => ({ ...state, helpscoutWorkspace: w }));
  },

  initIntegrationStore: () => set(initialState),
  set: (state) => set(state),
}));

export default useIntegrationStore;
